import { render, staticRenderFns } from "./towork-confirm.vue?vue&type=template&id=4bfe1b46&"
import script from "./towork-confirm.vue?vue&type=script&lang=js&"
export * from "./towork-confirm.vue?vue&type=script&lang=js&"
import style0 from "./towork-confirm.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports